<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12">
        <v-form class="mb-4" @submit.prevent="searchOrders">
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <div class="mt-3">検索条件を入力してください</div>
              <v-layout v-if="selectedSite" row class="pt-3">
                <v-select
                  v-model="searchQuery.statusEq"
                  :items="selectableOrderStatuses"
                  style="max-width: 200px"
                  class="ma-2"
                  clearable
                  dense
                  label="ステータス"
                />
                <v-text-field
                  v-model="searchQuery.idEq"
                  label="発注ID"
                  style="max-width: 150px"
                  type="number"
                  clearable
                  dense
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.lotNameCont"
                  label="ロット名"
                  style="max-width: 150px"
                  clearable
                  dense
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.postClassificationCont"
                  label="記事種別"
                  style="max-width: 150px"
                  clearable
                  dense
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.userNameCont"
                  label="ライター名"
                  style="max-width: 150px"
                  clearable
                  dense
                  class="ma-2"
                />
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  class="ma-2"
                  type="submit"
                  @click="searchOrders"
                  @submit.prevent="searchOrders"
                >
                  検索
                </v-btn>
              </v-layout>
              <v-layout v-else row>
                <v-alert outlined type="error" dense class="caption ml-5 mt-2">
                  対象サイトを選択してください。
                </v-alert>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>

        <client-inspection-management-table
          :orders="orders"
          :site="selectedSite"
          @request-client-completion="requestClientCompletion"
          @update-client-completed-on="updateClientCompletedOn"
        />

        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>

        <v-dialog v-model="displayResultMessages" scrollable width="500">
          <v-card>
            <v-card-title> クライアント校了結果 </v-card-title>
            <v-card-text>
              <v-alert
                v-if="successResultMessages().length !== 0"
                dense
                outlined
                type="success"
              >
                <li
                  v-for="result in successResultMessages()"
                  :key="result.id"
                  class="caption"
                >
                  発注ID:{{ result.id }} {{ result.message }}
                </li>
              </v-alert>
              <v-alert
                v-if="errorResultMessages().length !== 0"
                dense
                outlined
                type="error"
              >
                <li
                  v-for="result in errorResultMessages()"
                  :key="result.id"
                  class="caption"
                >
                  発注ID:{{ result.id }} {{ result.message }}
                </li>
              </v-alert>
            </v-card-text>

            <v-card-actions class="justify-end">
              <v-btn text @click="displayResultMessages = false">閉じる</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import Qs from 'qs'
import InfiniteLoading from 'vue-infinite-loading'
import ClientInspectionManagementTable from '@/components/masterAdminLayout/orders/clientInspectionManagement/Table.vue'
import order_utils from '@/mixins/order_utils'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    InfiniteLoading,
    ClientInspectionManagementTable
  },
  mixins: [order_utils, headUtilsMixin],
  data: () => {
    return {
      pageTitle: '検収管理',
      selectedSite: null,
      searchQuery: {
        idEq: '',
        statusEq: '',
        lotNameCont: '',
        postClassificationCont: '',
        userNameCont: ''
      },
      infiniteId: +new Date(),
      orders: [],
      resultMessages: [],
      displayResultMessages: false
    }
  },
  computed: {
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  created () {
    this.$watch(
      () => this.$route.params,
      (params) => {
        this.selectedSite = this.selectableSites.find(
          (site) => site.siteKey === params.siteKey
        )
        this.searchOrders()
      }
    )
  },
  mounted () {
    this.selectedSite = this.selectableSites.find(
      (site) => site.siteKey === this.$route.params.siteKey
    )
    this.searchOrders()
  },
  methods: {
    searchOrders () {
      this.page = 1
      this.orders = []
      this.infiniteId++
    },
    selectedSiteKey () {
      return this.selectedSite.siteKey
    },
    infiniteHandler ($state) {
      if (!this.selectedSite) {
        $state.complete()
        return true
      }

      axios
        .get('/api/master/orders', {
          params: {
            page: this.page,
            q: this.searchQuery,
            site_key: this.selectedSiteKey()
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedOrders = deserialize(data).data
          if (fetchedOrders.length > 0) {
            this.page++
            this.orders = this.orders.concat(fetchedOrders)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    requestClientCompletion (orderIds, deadline) {
      this.$store.dispatch('LoaderStore/displayLoader')

      const params = {
        siteKey: this.selectedSiteKey(),
        order: { ids: orderIds, client_completion_deadline: deadline }
      }
      axios.patch('/api/master/orders/request_client_completion', params).then(
        ({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.searchOrders()
          this.resultMessages = data
          this.displayResultMessages = true
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    successResultMessages () {
      return this.resultMessages.filter((result) => result.successful)
    },
    errorResultMessages () {
      return this.resultMessages.filter((result) => !result.successful)
    },
    updateClientCompletedOn (order) {
      this.$store.dispatch('LoaderStore/displayLoader')

      const params = {
        siteKey: this.selectedSiteKey(),
        order: { id: order.id, clientCompletedOn: order.clientCompletedOn }
      }
      axios.patch(`/api/master/orders/${order.id}`, params).then(
        ({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.dialog = false
          const updatedOrder = deserialize(data).data
          Object.assign(
            this.orders.find((order) => order.id === updatedOrder.id),
            updatedOrder
          )
          const payload = {
            status: 200,
            message: 'クライアント校了日を更新しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    }
  }
}
</script>
